import React from "react";
import { Link } from "react-router-dom";
import "./Welcome.css";
import Header from "./Header";

const Welcome = () => {
  return (
    <div>
    <Header/>
    <div className="welcome-container">
      <div className="welcome-content">
        <h1 className="welcome-title">Welcome to VMRDA Venue Booking</h1>
        <p className="welcome-subtitle">
          Your premier platform for booking prestigious venues
        </p>

     
      </div>
    </div>
    </div>
  );
};

export default Welcome;
